import React from "react";
import CreatorDetails from "../../../pages/ChangeRequest/activities/creatorDetails";
import { ucFirst } from "../../../helpers/string_helper";
import { Action } from "../../../constants/Common";
import ArrowRightAltOutlinedIcon from "@mui/icons-material/ArrowRightAltOutlined";
import { Modules } from "../../../constants/Module";
import { withTranslation } from "react-i18next";
function AgendaItem({ item, t }) {
  return (
    <div>
      <div>
        <strong>
          {t('Agenda Item')} ({typeof item?.payload?.description === 'object' ? item?.payload?.description.old : item?.payload?.description}){" "}
        </strong> {item.event !== Action.UPDATE && ( <span>{t('was associate with')} <strong>{t('agenda')} ({item?.payload?.agenda?.name})</strong></span>)} {item.event === Action.CREATE ? t("was added under") : item.event === Action.UPDATE ? t("was updated for") : t("was deleted from")}{" "}
        <strong>
          {t('startup')} {ucFirst(item.project?.name)} (
          {item?.project?.uniqueProjectId})
        </strong>{" "}
        {t('by')}
        <CreatorDetails creator={item?.creator} date={item?.createdAt} />
      </div>
      {item?.event === Action?.UPDATE && (
        <div>
          {typeof item?.payload?.description === "object" && 
           item?.payload?.description?.old && item?.payload?.description?.new && (
            <div className="mx-2">
              <div className="d-flex align-items-center change_status">
                <strong> {t('Agenda Item')}:</strong>
                <div className="d-flex align-items-center mx-2">
                  <span>{item?.payload?.description?.old}</span>
                </div>
                <span className="middleArrow mx-2">
                  <ArrowRightAltOutlinedIcon />
                </span>
                <div className="d-flex align-items-center">
                  <span className="mx-2">
                    {item?.payload?.description?.new}
                  </span>
                </div>
              </div>
            </div>
          )}
           {typeof item?.payload?.status === "object" && 
           item?.payload?.status?.old && item?.payload?.status?.new && (
            <div className="mx-2">
              <div className="d-flex align-items-center change_status">
                <strong> {t('Status')}:</strong>
                <div className="d-flex align-items-center mx-2">
                  <span>{item?.payload?.status?.old.name}</span>
                </div>
                <span className="middleArrow mx-2">
                  <ArrowRightAltOutlinedIcon />
                </span>
                <div className="d-flex align-items-center">
                  <span className="mx-2">
                    {item?.payload?.status?.new.name}
                  </span>
                </div>
              </div>
            </div>
          )}
          
        </div>
      )}
    </div>
  );
}
export default withTranslation()(AgendaItem);